import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ListingCard } from "@/components/ListingCard";
import { CATEGORIES } from "@/lib/constants";

export function FeaturedCategories({ groups }) {
  if (!groups.length) return null;
  return (
    <section data-testid="home-featured-categories" className="mx-auto mt-20 max-w-7xl space-y-12 px-4 sm:px-6 lg:px-8">
      {groups.map((g) => {
        const Icon = CATEGORIES.find((c) => c.id === g.category)?.icon;
        return (
          <div key={g.category} data-testid={`featured-row-${g.category}`}>
            <div className="mb-5 flex items-end justify-between gap-4">
              <h2 className="flex items-center gap-2 font-display text-xl font-bold sm:text-2xl">
                {Icon && <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#d4f253] text-[#0f2a33]"><Icon className="h-5 w-5" /></span>}
                New in {g.name}
              </h2>
              <Link to={`/browse?category=${g.category}&hide_sold=1`} data-testid={`featured-see-all-${g.category}`} className="flex shrink-0 items-center gap-1 text-sm font-semibold text-[#d4f253] hover:underline">See all {g.count} <ArrowRight className="h-4 w-4" /></Link>
            </div>
            <div className="scrollbar-none -mx-4 flex snap-x gap-4 overflow-x-auto px-4 pb-2 sm:mx-0 sm:px-0">
              {g.items.map((l, i) => (
                <div key={l.id} className="w-[46%] shrink-0 snap-start sm:w-[31%] lg:w-[23%]"><ListingCard l={l} i={i} /></div>
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
}
